import { ReactComponent as Plus } from "../../../../../assets/icons/createPlus.svg";
import { useRef, useState } from "react";
import { PopupModal } from "../PopupModal/PopupModal";
import { StyledGlobalCreateButtonDiv } from "./GlobalCreateButton.styles";
import { GlobalCreateMenu } from "../../../../globalMenuV1";

export const GlobalCreateButton = () => {
  const [isOpenListDropDown, setIsOpenListDropDown] = useState(false);
  const wasOpenOnPressRef = useRef(false);

  const handleMouseDown = () => {
    wasOpenOnPressRef.current = isOpenListDropDown;
  };
  const toggleDropDown = () => {
    const wasOpen = wasOpenOnPressRef.current;
    wasOpenOnPressRef.current = false;
    setIsOpenListDropDown(!wasOpen);
  };
  const handleClose = () => setIsOpenListDropDown(false);
  return (
    <StyledGlobalCreateButtonDiv className="item">
      <Plus onClick={toggleDropDown} onMouseDown={handleMouseDown} />
      {isOpenListDropDown ? <CreateButtonList handleClose={handleClose} /> : null}
    </StyledGlobalCreateButtonDiv>
  );
};

const CreateButtonList = ({ handleClose }) => {
  return (
    <PopupModal closeModal={handleClose}>
      <GlobalCreateMenu handleClose={handleClose} />
    </PopupModal>
  );
};
